var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBecomeAMentorPageLandingSun(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 151,
    height: 298,
    viewBox: "0 0 151 298",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M151 148.72L95.4503 135.558V148.72H151ZM85.1902 103.638L94.2066 128.407L141.88 97.0048L85.1902 103.638ZM81.6665 97.4193L115.66 51.6115L64.6699 77.2099L81.6665 97.4193ZM59.1772 72.6499L75.5519 17.9293L36.3769 59.488L59.1772 72.6499ZM29.5368 57.0006L26.2204 -1.52588e-05L3.52379 52.4406L29.5368 57.0006ZM0.000152588 68.608V148.72H80.112C80.112 104.467 44.2534 68.608 0.000152588 68.608Z",
    fill: "#007DA6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M151 148.721L95.4503 161.883V148.721H151ZM85.1902 193.803L94.2066 169.034L141.88 200.436L85.1902 193.803ZM81.6665 200.021L115.66 245.829L64.6699 220.231L81.6665 200.021ZM59.1772 224.791L75.5519 279.511L36.3769 237.953L59.1772 224.791ZM29.5368 240.44L26.2204 297.441L3.52379 245L29.5368 240.44ZM0.000152588 228.833V148.721H80.112C80.112 192.974 44.2534 228.833 0.000152588 228.833Z",
    fill: "#FFC456"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBecomeAMentorPageLandingSun);
export default __webpack_public_path__ + "static/media/BecomeAMentorPageLandingSun.f570b07c9898ed4bf05b522988d0af41.svg";
export { ForwardRef as ReactComponent };